import { useState, useEffect } from 'react';

type Theme = 'light' | 'dark';

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => {
    if (typeof window === 'undefined') return 'light';
    
    // Récupérer le thème depuis localStorage ou détecter la préférence système
    const savedTheme = localStorage.getItem('theme') as Theme;
    if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark')) {
      return savedTheme;
    }
    
    // Détecter la préférence système
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  // Appliquer le thème au document
  useEffect(() => {
    const root = window.document.documentElement;

    // Supprimer les classes de thème existantes
    root.classList.remove('light', 'dark');

    // Appliquer le thème actuel
    root.classList.add(theme);

    // Stocker le thème choisi
    localStorage.setItem('theme', theme);
    
    console.log('🎨 [THEME] Thème appliqué:', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(currentTheme => currentTheme === 'light' ? 'dark' : 'light');
  };

  return {
    theme,
    toggleTheme,
  };
}